/**
 * Front-end only discriminator between the current state and the proposal.
 * The API has no counterpart — it splits these into separate `currentContract*`
 * and `contractProposal*` endpoints instead.
 */
export const SolutionType = {
  Current: "Current",
  Proposed: "Proposed",
} as const;

export type SolutionType = (typeof SolutionType)[keyof typeof SolutionType];
